// extracted by mini-css-extract-plugin
export default {"searchResultsCollapse":"SearchResults_searchResultsCollapse__wfP2C"};